import React, { Fragment } from 'react'

import CollapsibleList from 'components/ui/CollapsibleList/CollapsibleList'
import LayerLink from './LayerLink/LayerLink'



const LayersList = ({ children, className, layers, onClick }) => (
  <div className={className}>
    {
      layers.public.map(({ id, link, title, isActive, toOLD, onLinkClick }, index) => (
        <Fragment key={index}>
          <LayerLink
            {...{ id, link, title, isActive, toOLD }}
            onClick={() => {
              if (typeof onLinkClick === 'function') {
                onLinkClick()
              }
              else if (typeof onClick === 'function') {
                onClick()
              }
            }}
          />
          {
            Boolean(typeof children === 'function' && isActive) && (
              children({ id })
            )
          }
        </Fragment>
      ))
    }
    {
      Boolean(layers.business.length) && (
        <CollapsibleList
          title="Бизнес"
        >
          {
            layers.business.map(({ id, link, title, isActive, toOLD, onLinkClick }) => (
              <LayerLink
                key={id}
                {...{ id, link, title, isActive, toOLD }}
                onClick={() => {
                  if (typeof onLinkClick === 'function') {
                    onLinkClick()
                  }
                  else if (typeof onClick === 'function') {
                    onClick()
                  }
                }}
              />
            ))
          }
        </CollapsibleList>
      )
    }
    {
      Boolean(layers.service.length) && (
        <CollapsibleList
          title="Служебные слои"
        >
          {
            layers.service.map(({ id, link, title, isActive, toOLD, onLinkClick }) => (
              <LayerLink
                key={id}
                {...{ id, link, title, isActive, toOLD }}
                onClick={() => {
                  if (typeof onLinkClick === 'function') {
                    onLinkClick()
                  }
                  if (typeof onClick === 'function') {
                    onClick()
                  }
                }}
              />
            ))
          }
        </CollapsibleList>
      )
    }
  </div>
)


export default LayersList
